import { InspectionListItem } from "@/model/InspectionListItem.ts";
import { PageReq, PageRes } from "@/dto/PageDto.ts";
import { Type } from "class-transformer";
import { SearchTypeEnum } from "@/enum/SearchTypeEnum.ts";
import { ChargingTypeEnum } from "@/enum/ChargingTypeEnum.ts";

/**
 * 보고서 리스트 조회 - req
 */
export class ReadInspectionListReqDto extends PageReq {
    startDate?: string;
    endDate?: string;
    /**
     * 급속 / 완속
     */
    chargingType?: ChargingTypeEnum;
    /**
     * false: 임시저장, true: 저장완료
     */
    isCompleted?: boolean;
    /**
     * false: 부정합, true: 정합
     */
    isNotCorrect?: boolean;
    /**
     * 작성자 아이디
     */
    inspectorId?: string;
    /**
     * 검색유형
     */
    searchType?: SearchTypeEnum;
}

/**
 * 보고서 리스트 조회 - res
 */
export class ReadInspectionListResDto extends PageRes<InspectionListItem> {
    /**
     * plain data > dto 로 변경
     */
    @Type(() => InspectionListItem)
    declare content: InspectionListItem[];
}
